import Iconify from '@/components/iconify';
import { PATH_DASHBOARD } from '@/routes/paths';
import { Button, Card, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// ----------------------------------------------------------------------

/**
 * Atalho para Integrações › Cakto MCP dentro de Cakto API.
 *
 * A configuração do MCP saiu daqui para uma página própria. O atalho fica
 * porque o MCP ainda entra com Chave de API: quem chega aqui para criar uma
 * chave é justamente quem pode querer conectar a IA, e o card de uma linha
 * avisa sem empurrar a tabela de chaves para baixo da dobra.
 */
export default function CaktoApiMcpCard() {
  return (
    <Card sx={{ px: 3, py: 2 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
      >
        <Stack spacing={0.5}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Iconify icon="eva:cube-outline" width={24} sx={{ color: 'success.main' }} />
            <Typography variant="h6">CaktoMCP</Typography>
          </Stack>
          <Typography variant="body2" color="text.secondary">
            Conecte o Claude (ou outro assistente de IA) à sua conta Cakto e opere a API pela
            conversa.
          </Typography>
        </Stack>

        <Button
          size="small"
          variant="outlined"
          component={RouterLink}
          to={PATH_DASHBOARD.general.caktoMcp}
          endIcon={<Iconify icon="eva:arrow-ios-forward-fill" />}
          sx={{ textTransform: 'none', flexShrink: 0 }}
        >
          Configurar o CaktoMCP
        </Button>
      </Stack>
    </Card>
  );
}
